/** Hàm thuần của ô "Tiền bo" trong tờ thu tiền (KH-GĐ2 5.2) — tách khỏi component để test không cần trình duyệt. */
import type { HinhThucThu, TienBoGui } from './api.ts'

export interface BoNhap {
  bat: boolean
  /** Chuỗi đồng (chỉ chữ số). */
  soTien: string
  hinhThuc: HinhThucThu
  thoIds: string[]
  /** Nhập tay số từng thợ; tắt = máy chủ chia đều (tròn 1.000đ, phần dư cho người đầu). */
  nhapTay: boolean
  phan: Record<string, string>
}

export function boMoi(thoIds: string[]): BoNhap {
  return { bat: false, soTien: '', hinhThuc: 'cash', thoIds, nhapTay: false, phan: {} }
}

const chanNghin = (s: string) =>
  s !== '' && /^\d+$/.test(s) && BigInt(s) > 0n && BigInt(s) % 1000n === 0n

/** Hợp lệ để gửi: tắt, hoặc bật với số chẵn nghìn, ≥ 1 thợ, và (nhập tay) tổng các phần = số bo. */
export function boHopLe(b: BoNhap): boolean {
  if (!b.bat) return true
  if (!chanNghin(b.soTien) || b.thoIds.length === 0) return false
  if (!b.nhapTay) return true
  const tong = b.thoIds.reduce(
    (t, id) => t + BigInt(b.phan[id] === '' ? '0' : (b.phan[id] ?? '0')),
    0n,
  )
  return (
    tong === BigInt(b.soTien) &&
    b.thoIds.every((id) => (b.phan[id] ?? '') === '' || BigInt(b.phan[id] ?? '0') % 1000n === 0n)
  )
}

/** Thân gửi máy chủ (gọi khi `bat` và hợp lệ — nút thu đã bị khoá nếu không hợp lệ). */
export function boGui(b: BoNhap): TienBoGui {
  return {
    soTienVnd: b.soTien,
    hinhThuc: b.hinhThuc,
    thoIds: b.thoIds,
    ...(b.nhapTay
      ? {
          phan: b.thoIds.map((id) => ({
            staffId: id,
            soTienVnd: b.phan[id] === '' ? '0' : (b.phan[id] ?? '0'),
          })),
        }
      : {}),
  }
}
